import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { OcrResult } from '@/features/ocr';
import type {
  OcrQaContainerListItem,
  OcrQaListParams,
  OcrQaMetrics,
  OcrQaResult,
  OcrQaTier,
  SubmitContainerVerdictParams,
  SubmitOcrQaPageVerdictParams,
  SubmitOcrQaVerdictParams,
  UpdateOcrQaFieldParams
} from '../types';

const { OCR_QA } = API_ENDPOINTS;

export const ocrQaApi = {
  getList: (tier: OcrQaTier, params?: OcrQaListParams) =>
    apiClient.getPaginated<OcrQaContainerListItem>(OCR_QA.LIST(tier), params),

  getMetrics: (tier: OcrQaTier) =>
    apiClient.get<OcrQaMetrics>(OCR_QA.METRICS(tier)),

  getById: (tier: OcrQaTier, resultId: number) =>
    apiClient.get<OcrQaResult>(OCR_QA.SHOW(tier, resultId)),

  getContainerResults: (tier: OcrQaTier, containerId: number) =>
    apiClient.get<OcrQaResult[]>(OCR_QA.CONTAINER_RESULTS(tier, containerId)),

  start: (tier: OcrQaTier, resultId: number) =>
    apiClient.post<OcrQaResult>(OCR_QA.START(tier, resultId), {}),

  submitVerdict: ({
    tier,
    resultId,
    verdict,
    notes,
    pageNotes
  }: SubmitOcrQaVerdictParams) =>
    apiClient.post<OcrQaResult>(OCR_QA.SUBMIT_VERDICT(tier, resultId), {
      tier,
      verdict,
      notes,
      page_notes: pageNotes ?? undefined
    }),

  submitPageVerdict: ({
    tier,
    resultId,
    pageNumber,
    verdict,
    notes
  }: SubmitOcrQaPageVerdictParams) =>
    apiClient.post<OcrQaResult>(
      OCR_QA.SUBMIT_PAGE_VERDICT(tier, resultId, pageNumber),
      { verdict, notes: notes ?? null }
    ),

  submitContainerVerdict: ({
    tier,
    containerId,
    verdict,
    notes,
    pageNotes
  }: SubmitContainerVerdictParams) =>
    apiClient.post<OcrResult[]>(OCR_QA.CONTAINER_VERDICT(tier, containerId), {
      verdict,
      notes: notes ?? null,
      page_notes: pageNotes ?? undefined
    }),

  updateField: ({
    tier,
    resultId,
    key,
    value,
    pageNumber
  }: UpdateOcrQaFieldParams) =>
    apiClient.put<OcrQaResult>(OCR_QA.UPDATE_FIELD(tier, resultId), {
      key,
      value,
      page_number: pageNumber ?? null
    })
};
